// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___9caa78c53ee7087deeb","cls2":"SimplePaperPodcast-cls2__eaa945110fb60dd1cb50 SimplePaperPodcast-cls1___9caa78c53ee7087deeb"};